module.exports = __webpack_public_path__ + "static/Семенова СС1.jpg";